<template>
	<div class="app-container">
		<!-- 搜索过滤 -->
		<el-card class="filter-card">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item>
					<el-button type="primary" @click="handleAdd">
						<el-icon>
							<Plus />
						</el-icon> 新建合同
					</el-button>
				</el-form-item>
				<el-form-item>
					<el-divider direction="vertical"></el-divider>
				</el-form-item>
				<el-form-item label="合同编号">
					<el-input v-model="filterForm.contractNumber" placeholder="请输入合同编号" clearable
						@keyup.enter="handleSearch" />
				</el-form-item>
				<el-form-item label="客户名称">
					<!-- <el-input v-model="filterForm.customerName" placeholder="请输入客户名称" clearable @keyup.enter="handleSearch" /> -->
					<el-select v-model="filterForm.customerId" placeholder="请选择客户" filterable remote
						:remote-method="handleCustomerSearch" :loading="customerSearchLoading" clearable>
						<el-option v-for="item in customerOptions" :key="item.id" :label="item.customerName"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="客户名称">
                    <el-input v-model="filterForm.customerName" placeholder="请输入客户名称" clearable
                        @keyup.enter="handleSearch" />
                </el-form-item> -->
				<el-form-item label="合同状态">
					<el-select v-model="filterForm.type" placeholder="请选择商机状态" style="width: 150px;">
						<el-option label="全部" value="all"></el-option>
						<el-option label="我的" value="my"></el-option>
						<el-option label="下属的" value="subordinate"></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="合同状态">
                    <el-select v-model="filterForm.status" placeholder="请选择状态" clearable>
                        <el-option label="草稿" :value="0" />
                        <el-option label="待审核" :value="1" />
                        <el-option label="已生效" :value="2" />
                        <el-option label="已到期" :value="3" />
                        <el-option label="已终止" :value="4" />
                    </el-select>
                </el-form-item> -->
				<!-- <el-form-item label="签订日期">
                    <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="YYYY-MM-DD">
                    </el-date-picker>
                </el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="handleSearch">
						<el-icon>
							<Search />
						</el-icon> 搜索
					</el-button>
					<el-button @click="resetForm">
						<el-icon>
							<Refresh />
						</el-icon> 重置
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 合同列表 -->
		<el-card class="table-card">
			<el-table :data="contractList" height="calc(100vh - 320px)" style="width: 100%" stripe v-loading="loading"
				ref="contractTable">
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="contractNumber" label="合同编号" />
				<el-table-column prop="customerName" label="客户名称" />
				<el-table-column prop="contractName" label="合同名称" show-overflow-tooltip />
				<el-table-column prop="amount" label="合同金额" width="120">
					<template #default="scope">
						{{ formatAmount(scope.row.amount) }}
					</template>
				</el-table-column>
				<el-table-column prop="signedDate" label="签订日期" width="120">
					<template #default="scope">
						{{ formatDate(scope.row.signedDate) }}
					</template>
				</el-table-column>
				<el-table-column prop="startDate" label="生效日期" width="120">
					<template #default="scope">
						{{ formatDate(scope.row.startDate) }}
					</template>
				</el-table-column>
				<el-table-column prop="endDate" label="到期日期" width="120">
					<template #default="scope">
						{{ formatDate(scope.row.endDate) }}
					</template>
				</el-table-column>
				<!-- <el-table-column prop="status" label="状态" width="100">
                    <template #default="scope">
                        <el-tag :type="getStatusType(scope.row.status)">
                            {{ getStatusText(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column> -->
				<el-table-column label="操作" width="200" fixed="right">
					<template #default="scope">
						<el-button size="small" type="warning" @click="handleView(scope.row)">查看</el-button>
						<el-button size="small" type="primary" @click="handleEdit(scope.row)">编辑</el-button> 
						<el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
						<!-- <el-button v-if="scope.row.status === 0" size="mini" type="success"
                            @click="handleSubmit(scope.row)">提交审核</el-button>
                        <el-button v-if="scope.row.status === 1" size="mini" type="warning"
                            @click="handleApprove(scope.row)">审核</el-button> -->
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-container">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-card>

		<!-- 新建/编辑合同对话框 -->
		<el-dialog class="mydialog" :title="dialogTitle" v-model="dialogVisible" width="50vw"
			:close-on-click-modal="false" align-center>
			<el-form :model="contractForm" :rules="rules" ref="contractForm" label-width="100px"
				v-loading="dialogLoading">
				<el-row>
					<el-col :span="12">
						<el-form-item label="合同编号" prop="contractNumber">
							<el-input v-model="contractForm.contractNumber" placeholder="请输入合同编号" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="合同名称" prop="contractName">
							<el-input v-model="contractForm.contractName" placeholder="请输入合同名称" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="客户名称" prop="customerId">
							<el-select v-model="contractForm.customerId" placeholder="请选择客户" filterable remote
								:remote-method="handleCustomerSearch" :loading="customerSearchLoading"
								@change="handleCustomerChange">
								<el-option v-for="item in customerOptions" :key="item.id" :label="item.customerName"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="所属商机" prop="businessId">
							<el-select v-model="contractForm.businessId" placeholder="请选择商机" filterable
								:loading="opportunityLoading">
								<el-option v-for="item in opportunityOptions" :key="item.id" :label="item.name"
									:value="item.id">
									<span>{{ item.name }}</span>
									<!-- <span style="float: right; color: #8492a6; font-size: 13px">
                                金额: {{ formatAmount(item.totalAmount) }}
                            </span> -->
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="合同金额" prop="totalAmount">
					<el-input-number v-model="contractForm.totalAmount" :precision="2" :step="1000" :min="0"
						style="width: 200px" />
				</el-form-item>
				<el-row>
					<el-col :span="12">
						<el-form-item label="签订日期" prop="signedDate">
							<el-date-picker v-model="contractForm.signedDate" type="date" placeholder="选择日期"
								value-format="YYYY-MM-DD">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="生效日期" prop="startDate">
							<el-date-picker v-model="contractForm.startDate" type="date" placeholder="选择日期"
								value-format="YYYY-MM-DD">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="到期日期" prop="endDate">
							<el-date-picker v-model="contractForm.endDate" type="date" placeholder="选择日期"
								value-format="YYYY-MM-DD">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="20">
						<el-form-item label="合同内容" prop="paymentTerms">
							<el-input v-model="contractForm.paymentTerms" type="textarea" :rows="3"
								placeholder="请输入付款条款" />
						</el-form-item>
					</el-col>
					<el-col :span="20">
						<el-form-item label="备注说明" prop="notes">
							<el-input v-model="contractForm.notes" type="textarea" :rows="2" placeholder="请输入备注说明" />
						</el-form-item>
					</el-col>
					<el-col :span="20">
						<el-form-item label="合同文件" prop="contractFile"
							:rules="[{ required: true, message: '请上传合同文件', trigger: 'change' }]">
							<el-upload action="/api/move/uploadPic" :on-preview="handleContractFilePreview"
								:on-remove="handleContractFileRemove" :on-success="handleContractFileSuccess"
								:before-upload="beforeContractFileUpload" :headers="uploadHeaders" :limit="1"
								:on-exceed="handleContractFileExceed" :file-list="contractFileList" accept=".pdf"
								class="contract-upload">
								<el-button type="primary">选择文件</el-button>
								<template #tip>
									<div class="el-upload__tip">只能上传PDF文件</div>
								</template>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitForm" :loading="submitLoading">
						确 定
					</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 查看合同详情对话框 -->
		<el-dialog class="mydialog" title="合同详情" v-model="viewDialogVisible" width="50vw" :close-on-click-modal="false"
			align-center>
			<el-tabs v-model="activeTab" type="border-card">
				<el-tab-pane label="基本信息" name="basic">
					<div class="contacts-section">
						<el-descriptions :column="2" border>
							<el-descriptions-item label="合同编号">{{ viewContract.contractNumber }}</el-descriptions-item>
							<el-descriptions-item label="合同名称">{{ viewContract.contractName }}</el-descriptions-item>
							<el-descriptions-item label="客户名称">{{ viewContract.customerName }}</el-descriptions-item>
							<el-descriptions-item label="所属商机">{{ viewContract.businessName }}</el-descriptions-item>
							<el-descriptions-item
								label="合同金额">{{ formatAmount(viewContract.totalAmount) }}</el-descriptions-item>
							<el-descriptions-item
								label="签订日期">{{ formatDate(viewContract.signedDate) }}</el-descriptions-item>
							<el-descriptions-item
								label="生效日期">{{ formatDate(viewContract.startDate) }}</el-descriptions-item>
							<el-descriptions-item
								label="到期日期">{{ formatDate(viewContract.endDate) }}</el-descriptions-item>
							<el-descriptions-item label="付款条款" :span="2">
								<span style="white-space: pre-wrap">{{ viewContract.paymentTerms || '无' }}</span>
							</el-descriptions-item>
							<el-descriptions-item label="备注说明" :span="2">
								<span style="white-space: pre-wrap">{{ viewContract.notes || '无' }}</span>
							</el-descriptions-item>
							<el-descriptions-item label="合同文件" :span="2">
								<el-link v-if="viewContract.contractFile" type="primary"
									@click="handleContractFilePreview({url: viewContract.url})">
									查看合同文件
								</el-link>
								<span v-else>无</span>
							</el-descriptions-item>
						</el-descriptions>
					</div>
				</el-tab-pane>

				<!-- <el-tab-pane label="审批流程" name="process" v-if="viewContract.process">
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in viewContract.process"
              :key="index"
              :type="getTimelineItemType(activity.status)"
              :timestamp="formatDateTime(activity.updateTime)">
              <div class="timeline-item-content">
                <h4>第{{ index + 1 }}步</h4>
                <p><strong>审批人：</strong>{{ activity.username }}</p>
                <p><strong>审批状态：</strong>
                  <el-tag :type="getStatusType1(activity.status)" size="small">
                    {{ getStatusText1(activity.status) }}
                  </el-tag>
                </p>
                <p v-if="activity.examineOpinion"><strong>审批意见：</strong>{{ activity.examineOpinion }}</p>
              </div>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane> -->
			</el-tabs>
		</el-dialog>

		<!-- 审核对话框 -->
		<!-- <el-dialog
      title="合同审核"
      v-model="approveDialogVisible"
      width="500px">
      <el-form
        :model="approveForm"
        :rules="approveRules"
        ref="approveForm"
        label-width="100px">
        <el-form-item label="审核结果" prop="status">
          <el-radio-group v-model="approveForm.status">
            <el-radio :label="2">通过</el-radio>
            <el-radio :label="3">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见" prop="examineOpinion">
          <el-input
            type="textarea"
            v-model="approveForm.examineOpinion"
            :rows="4"
            placeholder="请输入审核意见" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="approveDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitApprove" :loading="approveLoading">
            确 定
          </el-button>
        </span>
      </template>
    </el-dialog> -->
	</div>
</template>

<script>
	import {
		Plus,
		Search,
		Refresh
	} from '@element-plus/icons-vue'
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'
	import dayjs from 'dayjs'
	import {
		getContractList,
		// getContractDetail,
		createContract,
		updateContract,
		submitContract,
		approveContract,
		// getContractProcess,
		searchCustomers,
		deleteContract
	} from '@/api/contract'
	import {
		getCustomerOpportunities
	} from '@/api/payment'

	export default {
		name: 'ContractManagement',
		components: {
			Plus,
			Search,
			Refresh
		},
		data() {
			return {

				loading: false,
				dialogLoading: false,
				submitLoading: false,
				approveLoading: false,
				customerSearchLoading: false,
				opportunityLoading: false,
				filterForm: {
					contractNumber: '',
					customerName: '',
					type: 'all',
					startDate: '',
					endDate: ''
				},
				dateRange: [],
				contractList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				dialogVisible: false,
				viewDialogVisible: false,
				approveDialogVisible: false,
				dialogTitle: '新建合同',
				viewContract: {},
				currentContract: null,
				activeTab: 'basic',
				customerOptions: [],
				opportunityOptions: [],
				contractForm: {
					contractNumber: '', // 合同编号
					contractName: '', // 合同名称
					customerId: '', // 客户ID
					customerName: '', // 客户名称（展示用）
					businessId: '', // 商机ID
					businessName: '', // 商机名称（展示用）
					totalAmount: 0, // 合同金额
					signedDate: '', // 签订日期
					startDate: '', // 生效日期
					endDate: '', // 到期日期
					paymentTerms: '', // 付款条款
					notes: '', // 备注说明
					contractFile: '', // 合同文件
					status: 0 // 合同状态
				},
				approveForm: {
					status: 2,
					examineOpinion: ''
				},
				rules: {
					contractNumber: [{
							required: true,
							message: '请输入合同编号',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 50,
							message: '长度在 3 到 50 个字符',
							trigger: 'blur'
						}
					],
					contractName: [{
							required: true,
							message: '请输入合同名称',
							trigger: 'blur'
						},
						{
							min: 2,
							max: 100,
							message: '长度在 2 到 100 个字符',
							trigger: 'blur'
						}
					],
					customerId: [{
						required: true,
						message: '请选择客户',
						trigger: 'change'
					}],
					businessId: [{
						required: true,
						message: '请选择商机',
						trigger: 'change'
					}],
					totalAmount: [{
							required: true,
							message: '请输入合同金额',
							trigger: 'blur'
						},
						{
							type: 'number',
							min: 0,
							message: '金额必须大于0',
							trigger: 'blur'
						}
					],
					signedDate: [{
						required: true,
						message: '请选择签订日期',
						trigger: 'change'
					}],
					startDate: [{
						required: true,
						message: '请选择生效日期',
						trigger: 'change'
					}],
					endDate: [{
							required: true,
							message: '请选择到期日期',
							trigger: 'change'
						},
						{
							validator: (rule, value, callback) => {
								if (value && this.contractForm.startDate && value < this.contractForm.startDate) {
									callback(new Error('到期日期不能早于生效日期'))
								} else {
									callback()
								}
							},
							trigger: 'change'
						}
					],
					paymentTerms: [{
							required: true,
							message: '请输入付款条款',
							trigger: 'blur'
						},
						{
							min: 10,
							max: 500,
							message: '长度在 10 到 500 个字符',
							trigger: 'blur'
						}
					],
					contractFile: [{
						required: true,
						message: '请上传合同文件',
						trigger: 'change'
					}]
				},
				approveRules: {
					status: [{
						required: true,
						message: '请选择审核结果',
						trigger: 'change'
					}],
					examineOpinion: [{
						required: true,
						message: '请输入审核意见',
						trigger: 'blur'
					}]
				},
				contractFileList: [],
				uploadHeaders: {
					Authorization: localStorage.getItem('token') || ''
				},
			}
		},
		watch: {
			dateRange(val) {
				if (val) {
					this.filterForm.startDate = val[0]
					this.filterForm.endDate = val[1]
				} else {
					this.filterForm.startDate = ''
					this.filterForm.endDate = ''
				}
			}
		},
		created() {
			// 获取路由参数
			const {
				number
			} = this.$route.query
			if (number) {
				// 设置搜索条件
				this.filterForm.contractNumber = number
				// 执行搜索
				this.handleSearch()
			} else {
				// 如果没有参数，获取默认列表
				this.fetchData()
			}
		},
		methods: {
			formatDate(date) {
				if (!date) return ''
				return dayjs(date).format('YYYY-MM-DD')
			},
			formatDateTime(date) {
				if (!date) return ''
				return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
			},
			formatAmount(amount) {
				if (!amount && amount !== 0) return '¥0.00'
				return `¥${Number(amount).toFixed(2)}`
			},
			getStatusType(status) {
				const statusMap = {
					0: 'info',
					1: 'warning',
					2: 'success',
					3: 'danger',
					4: 'info'
				}
				return statusMap[status] || 'info'
			},
			getStatusText(status) {
				const statusMap = {
					0: '草稿',
					1: '待审核',
					2: '已生效',
					3: '已到期',
					4: '已终止'
				}
				return statusMap[status] || status
			},
			getStatusType1(status) {
				const statusMap = {
					'-1': 'warning',
					0: 'primary',
					2: 'danger',
					1: 'success'
				}
				return statusMap[status] || 'info'
			},
			getStatusText1(status) {
				const statusMap = {
					'-1': '未进行',
					0: '审批中',
					2: '已拒绝',
					1: '已通过'
				}
				return statusMap[status] || status
			},
			getTimelineItemType(status) {
				const typeMap = {
					'-1': 'warning',
					0: 'primary',
					2: 'danger',
					1: 'success'
				}
				return typeMap[status] || 'info'
			},
			async fetchData() {
				this.loading = true
				try {
					const data = {
						current: this.currentPage,
						size: this.pageSize,
						...this.filterForm
					}
					const res = await getContractList(data)
					this.contractList = res.data.records
					this.contractList.forEach(item => {
						if (item.contractFile) {
							item.contractFile = "http://192.168.3.121:8080/move/getOssFile?name=" + item
								.contractFile
						}
					})
					this.total = res.data.total
				} catch (error) {
					console.error('获取合同列表失败:', error)
					ElMessage.error('获取合同列表失败')
				} finally {
					this.loading = false
				}
			},
			handleSearch() {
				this.currentPage = 1
				this.fetchData()
			},
			resetForm() {
				this.filterForm = {
					contractNumber: '',
					customerName: '',
					type: 'all',
					startDate: '',
					endDate: ''
				}
				this.dateRange = []
				this.contractFileList = []
				this.handleSearch()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchData()
			},
			handleAdd() {
				this.dialogTitle = '新建合同'
				this.contractForm = {
					contractNumber: '',
					contractName: '',
					customerId: '',
					businessId: '',
					totalAmount: 0,
					signedDate: '',
					startDate: '',
					endDate: '',
					paymentTerms: '',
					notes: '',
					status: 0
				}
				this.dialogVisible = true
			},
			handleEdit(row) {
				this.dialogTitle = '编辑合同'
				// 设置客户选项
				this.customerOptions = [{
					id: row.customerId,
					customerName: row.customerName
				}]
				// 设置商机选项
				this.opportunityOptions = [{
					id: row.businessId,
					name: row.businessName
				}]
				// 设置表单数据
				this.contractForm = {
					...row
				}
				if (row.contractFile) {
					this.contractFileList = [{
						name: '合同文件.pdf',
						url: row.contractFile,
						status: 'success'
					}]
				}
				this.dialogVisible = true
			},
			async handleView(row) {
				this.viewDialogVisible = true
				try {
					// const [detailRes, processRes] = await Promise.all([
					//     // getContractDetail(row.id),
					//     // getContractProcess(row.id)
					// ])

					this.viewContract = {
						...row
					}
				} catch (error) {
					console.error('获取合同详情失败:', error)
					ElMessage.error('获取合同详情失败')
				}
			},
			handleSubmit(row) {
				ElMessageBox.confirm('确认提交该合同进行审核吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					try {
						await submitContract(row.id)
						ElMessage.success('提交成功')
						this.fetchData()
					} catch (error) {
						console.error('提交合同失败:', error)
						ElMessage.error('提交失败')
					}
				}).catch(() => {})
			},
			handleApprove(row) {
				this.currentContract = row
				this.approveForm = {
					status: 2,
					examineOpinion: ''
				}
				this.approveDialogVisible = true
			},
			async handleCustomerSearch(query) {
				if (query) {
					this.customerSearchLoading = true
					try {
						const res = await searchCustomers({
							name: query
						})
						this.customerOptions = res.data
					} catch (error) {
						console.error('搜索客户失败:', error)
						ElMessage.error('搜索客户失败')
					} finally {
						this.customerSearchLoading = false
					}
				} else {
					this.customerOptions = []
				}
			},
			async handleCustomerChange(customerId) {
				if (customerId) {
					this.opportunityLoading = true
					try {
						const res = await getCustomerOpportunities({
							cuId: customerId
						})
						this.opportunityOptions = res.data
					} catch (error) {
						console.error('获取客户商机失败:', error)
						ElMessage.error('获取客户商机失败')
					} finally {
						this.opportunityLoading = false
					}
				} else {
					this.opportunityOptions = []
					this.contractForm.businessId = ''
				}
			},
			async submitForm() {
				try {
					await this.$refs.contractForm.validate()
					this.submitLoading = true

					if (this.contractForm.id) {
						await updateContract(this.contractForm)
						ElMessage.success('更新成功')
					} else {
						await createContract(this.contractForm)
						ElMessage.success('创建成功')
					}
					this.dialogVisible = false
					this.fetchData()
				} catch (error) {
					if (error.message) {
						ElMessage.error(error.message)
					}
					console.error('提交表单失败:', error)
				} finally {
					this.submitLoading = false
				}
			},
			async submitApprove() {
				try {
					await this.$refs.approveForm.validate()
					this.approveLoading = true

					await approveContract(this.currentContract.id, this.approveForm)
					ElMessage.success('审核成功')
					this.approveDialogVisible = false
					this.fetchData()
				} catch (error) {
					if (error.message) {
						ElMessage.error(error.message)
					}
					console.error('提交审核失败:', error)
				} finally {
					this.approveLoading = false
				}
			},
			beforeContractFileUpload(file) {
				const isPDF = file.type === 'application/pdf'
				const isLt10M = true

				if (!isPDF) {
					this.$message.error('只能上传PDF文件!')
					return false
				}
				if (!isLt10M) {
					this.$message.error('文件大小不能超过 10MB!')
					return false
				}
				return true
			},
			handleContractFileSuccess(response, file) {
				this.contractForm.contractFile = response.data
				this.contractFileList = [{
					name: file.name,
					url: response.data,
					status: 'success'
				}]
			},
			handleContractFileRemove() {
				this.contractForm.contractFile = ''
				this.contractFileList = []
			},
			handleContractFilePreview(file) {
				console.log(file)
				window.open(file.url)
			},
			handleContractFileExceed() {
				this.$message.warning('只能上传一个文件')
			},
			async handleDelete(row) {
				try {
					await this.$confirm('确认删除该合同吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					await deleteContract({
						id: row.id
					})
					this.$message.success('删除成功')
					this.fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('删除合同失败:', error)
						this.$message.error('删除失败')
					}
				}
			},
		}
	}
</script>

<style scoped>
	.contract-management {
		/* padding: 20px; */
	}

	.page-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}

	.header-actions {
		display: flex;
		gap: 10px;
	}

	.pagination-container {
		margin-top: 20px;
		text-align: right;
	}

	.timeline-item-content {
		padding: 8px 0;
	}

	.timeline-item-content h4 {
		margin: 0 0 8px 0;
		color: #303133;
	}

	.timeline-item-content p {
		margin: 4px 0;
		color: #606266;
		line-height: 1.5;
	}

	.el-dialog {
		display: flex;
		flex-direction: column;
		margin: 0 !important;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		max-height: calc(100vh - 30px);
		max-width: calc(100vw - 30px);
	}

	.el-dialog__body {
		flex: 1;
		overflow: auto;
		padding: 20px;
	}

	.el-timeline {
		margin: 0;
		padding: 0;
	}

	.contract-upload {
		margin-top: 10px;
	}

	.el-upload__tip {
		line-height: 1.2;
		padding-top: 5px;
		color: #909399;
	}
</style>
